export const MAX_IDLE_TIME = 15 * 60 * 1000; // Manulifehnw security protocol 15 minutes
export const MODAL_COUNTDOWN_TIME = 1 * 60 * 1000;
export const MODAL_POPUP_TIME = MAX_IDLE_TIME - MODAL_COUNTDOWN_TIME;
export const DATE_FORMAT = 'YYYY-MM-DD';
